function readCSSBreakpoints() {
    return globalThis.getComputedStyle(document.documentElement, ':before').getPropertyValue('content').replace(/"/g, '').split(',');
}
/**
 * Reads the content property on the documentElement ::after pseudo element
 * for a string of the current breakpoint name. This value is updated using
 * dynamically using media queries and should match a value found in
 * the ::before pseudo element.
 *
 * @returns A string representing the current breakpoint name
 *
 */
function readCSSCurrentBreakpoint() {
    return globalThis.getComputedStyle(document.documentElement, ':after').getPropertyValue('content').replace(/"/g, '');
}
const callbacks = [];
// const cssBreakpoints = readCSSBreakpoints();
class CSSBreakpoint {
    constructor() { }
    get cssBreakpoint() {
        var _b;
        return ((_b = this._cssBreakpoint) !== null && _b !== void 0 ? _b : (this._cssBreakpoint = readCSSCurrentBreakpoint()));
    }
    get cssBreakpoints() {
        var _b;
        return ((_b = this._cssBreakpoints) !== null && _b !== void 0 ? _b : (this._cssBreakpoints = readCSSBreakpoints()));
    }
    /**
     * Checks whether this breakpoint is at least the input breakpoint
     *
     * @param breakpointName - The input breakpoint name
     * @returns Whether this breakpoint is the same or greater than the input breakpoint
     *
     */
    min(breakpointName) {
        const comparison = this.cssBreakpoints.indexOf(this.cssBreakpoint) - this.cssBreakpoints.indexOf(breakpointName);
        return comparison >= 0;
    }
    /**
     * Checks whether this breakpoint is at most the input breakpoint
     *
     * @param breakpointName - The input breakpoint name
     * @returns Whether this breakpoint is the same or less than the input breakpoint
     *
     */
    max(breakpointName) {
        const comparison = this.cssBreakpoints.indexOf(this.cssBreakpoint) - this.cssBreakpoints.indexOf(breakpointName);
        return comparison <= 0;
    }
    /**
     * Checks whether this breakpoint is at within the input breakpoint start
     * and input breakpoint end, inclusive
     *
     * @param breakpointNameStart - The starting input breakpoint name
     * @param breakpointNameEnd - The ending input breakpoint name
     * @returns Whether this breakpoint is the same or greater than the starting input
     *          breakpoint and the same or less than the ending input breakpoint
     *
     */
    range(breakpointNameStart, breakpointNameEnd) {
        const indexCurrent = this.cssBreakpoints.indexOf(this.cssBreakpoint);
        const indexStart = this.cssBreakpoints.indexOf(breakpointNameStart);
        const indexEnd = this.cssBreakpoints.indexOf(breakpointNameEnd);
        return indexStart <= indexCurrent && indexCurrent <= indexEnd;
    }
    is() {
        const _this = this;
        const breakpointNames = [];
        for (let _i = 0; _i < arguments.length; _i++) {
            breakpointNames[_i] = arguments[_i];
        }
        return breakpointNames.some(function (breakpoint) {
            return breakpoint === _this.cssBreakpoint;
        });
    }
}
const breakpoints = {
    previous: new CSSBreakpoint(),
    current: new CSSBreakpoint(),
};
const initBreakPoint = () => {
    breakpoints.previous.cssBreakpoint;
    breakpoints.previous.cssBreakpoints;
    breakpoints.current.cssBreakpoint;
    breakpoints.current.cssBreakpoints;
};
initBreakPoint();
/**
 * Gets the breakpoints
 *
 * @returns The current and previous breakpoint
 *
 */
export function get() {
    return breakpoints;
}
/**
 * Adds an event listener to be called when a breakpoint changes
 *
 * @param callback - The function to be called when a breakpoint changes
 *
 */
export function onChange(callback) {
    if (callbacks.indexOf(callback) === -1) {
        callbacks.push(callback);
    }
}
/**
 * Removes an event listener to be called when a breakpoint changes
 *
 * @param callback - The function to be removed from the set of event listeners
 *
 */
export function offChange(callback) {
    const index = callbacks.indexOf(callback);
    if (index !== -1) {
        callbacks.splice(index, 1);
    }
}
export const min = function (breakpointName) {
    return breakpoints.current.min(breakpointName);
};
export const max = function (breakpointName) {
    return breakpoints.current.max(breakpointName);
};
export const range = function (breakpointNameStart, breakpointNameEnd) {
    return breakpoints.current.range(breakpointNameStart, breakpointNameEnd);
};
export const is = function () {
    let _a;
    const breakpointNames = [];
    for (let _i = 0; _i < arguments.length; _i++) {
        breakpointNames[_i] = arguments[_i];
    }
    return (_a = breakpoints.current).is.apply(_a, breakpointNames);
};
/*
 * document.styleSheets is considered experimental technology; however,
 * the majority of current browsers implement this functionality.
 *
 * One drawback is under certain conditions, stylesheets may become
 * available due to security rules in the browser and we must be able to
 * fallback gracefully.
 */
const styleSheetList = document.styleSheets;
const mediaLists = Object.keys(styleSheetList).reduce(function (accumulator, key) {
    const stylesheet = styleSheetList[key];
    if (!stylesheet.href || stylesheet.href.indexOf('theme') === -1) {
        return accumulator;
    }
    try {
        const cssRules = stylesheet.cssRules;
        for (let i = 0; i < cssRules.length; i++) {
            const cssRule = stylesheet.cssRules[i];
            if (!(cssRule instanceof CSSMediaRule)) {
                continue;
            }
            for (let j = 0; j < cssRules.length; j++) {
                const cssMediaCssRule = cssRule.cssRules[j];
                if (!(cssMediaCssRule instanceof CSSStyleRule)) {
                    continue;
                }
                if (cssMediaCssRule.selectorText && cssMediaCssRule.selectorText.indexOf('html::after') !== -1) {
                    accumulator.push(cssRule.media);
                }
            }
        }
    }
    catch (_a) {
        return accumulator;
    }
    return accumulator;
}, []);
/*
 * Use globalThis.matchMedia when stylesheets are accessible in the browser.
 * matchMedia is theoretically more performant than listening to every resize
 * event because it only fires when a media query boundary is crossed.
 *
 * If stylesheets aren't available, revert back to using the resize event.
 */
if (mediaLists.length > 0) {
    mediaLists.forEach(function (mediaList) {
        const mql = globalThis.matchMedia(mediaList.mediaText);
        mql.addListener(function () {
            initBreakPoint();
            const cssCurrentBreakpoint = readCSSCurrentBreakpoint();
            if (breakpoints.current.cssBreakpoint !== cssCurrentBreakpoint) {
                breakpoints.previous = breakpoints.current;
                breakpoints.current = new CSSBreakpoint();
                callbacks.forEach(function (callback) {
                    return callback(breakpoints);
                });
            }
        });
    });
}
else {
    globalThis.addEventListener('resize', function () {
        initBreakPoint();
        const cssCurrentBreakpoint = readCSSCurrentBreakpoint();
        if (breakpoints.current.cssBreakpoint !== cssCurrentBreakpoint) {
            breakpoints.previous = breakpoints.current;
            breakpoints.current = new CSSBreakpoint();
            callbacks.forEach(function (callback) {
                return callback(breakpoints);
            });
        }
    });
}
const cjs = {
    get,
    onChange,
    offChange,
    min,
    max,
    range,
    is,
    readCSSCurrentBreakpoint,
    readCSSBreakpoints,
};
export default cjs;
